// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const postTorch = defineModel({
  id: "post-torch",
  batchId: "future",
  name: "Post torch",
  tags: ["scenery","post","torch","low-poly","age-of-mcp","future"],
  summary: "A post-mounted torch — simple open-flame lighting.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.12,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.025, 0.018, 0.62, 6), color: "#6f4a26", position: [0, 0.31, 0] },
      { geometry: new THREE.CylinderGeometry(0.018, 0, 0.08, 6), color: "#553820" },
      { geometry: new THREE.TorusGeometry(0.028, 0.008, 4, 8), color: "#caa674", position: [0, 0.5, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.045, 0.03, 0.1, 7), color: "#2a221a", position: [0, 0.62, 0] },
      { geometry: new THREE.ConeGeometry(0.05, 0.18, 6), color: "#ff8a2a", position: [0, 0.76, 0] },
      { geometry: new THREE.ConeGeometry(0.03, 0.22, 5), color: "#ffd24a", position: [0.005, 0.8, 0] },
      { geometry: new THREE.SphereGeometry(0.025, 5, 4), color: "#c43a20", position: [0, 0.68, 0] },
    ],
  animations: [],
});
